import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { translate } from 'src/app/project/features/translate/translate';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';

export function getAdvancedReminderCreatedByOptions(): TSelectOption[] {
  return [
    {
      value: EAdvancedFilterOptions.SHARED_BY_ME,
      label: translate('is_shared_by_me') + '.',
    },
    {
      value: EAdvancedFilterOptions.SHARED_WITH_ME,
      label: translate('is_shared_with_me') + '.',
    },
    {
      value: EAdvancedFilterOptions.PERSONAL,
      label: translate('is_personal') + '.',
    },
  ];
}
